import {objectToQueryString} from "@/lib/utils/url";
import {generalRequest} from "@/lib/services/requests";
import {myAcademy} from "@/lib/services/academyService";

import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminLessons = (config) => {
    return useQuery({
        queryKey: ['admin', 'poll', 'get', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/lessons`, config)
        })({params: config})),
    })
}


export const useApiSearchStudentLessons = (args = {}) => {
    return useQuery({
        queryKey: ['student', 'lessons', 'list', args, myAcademy()],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            const searchParams = objectToQueryString(config);
            return generalRequest.get(`/student/lessons?` + searchParams, config)
        })({...args, page: pageParam})),
    })
}


export const useApiSearchMyStudentLessons = (args = {}) => {
    return useQuery({
        enabled: !!args?.enabled,
        queryKey: ['student', 'my-lessons', 'list', args, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/student/my-lessons`, {params: config})
        })(args)),
    })
}


export const useApiReadStudentLessonFilters = () => {
    return useQuery({
        queryKey: ['student', 'lessons', 'list', 'filters', myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/student/lessons-filters`, config)
        })()),
    })
}


export const useApiReadStudentLessonId = (id) => {
    return useQuery({
        queryKey: ['student', 'lessons', 'detail', id, myAcademy()],
        queryFn: () => ((async (id = {}) => {
            return generalRequest.get(`/student/lessons/${id}`)
        })(id)),
    })
}


export const useApiCreateStudentLessonTaken = () => {
    return useMutation({
        mutationFn: (data) =>
            ((async (data) => {
                return generalRequest.post(`/student/lessons/${data.id}/register`, data)
            })(data))
    });
}


export const useApiStudentTransferLesson = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (id, newId) => {
                return generalRequest.post(`/student/lesson-transfer/${id}/${newId}`)
            })(args.id, args.newId))
    });
}


export const useApiStudentRemoveTakeLesson = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (id) => {
                return generalRequest.delete(`/student/lesson-registration/${id}`)
            })(args.id))
    });
}


export const useApiStudentStartExam = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (id) => {
                return generalRequest.post(`/student/lesson-registration/${id}/exam`)
            })(args.id))
    });
}

export const useApiReadStudentLessonDetail = (id) => {
    return useQuery({
        queryKey: ['student', 'lessons', 'my-lesson', 'detail', id, myAcademy()],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/student/lesson-registration/${id}`)
        })(id)),
    })
}


export const useApiReadStudentLessonDetailRaw = (id) => {
    return useQuery({
        queryKey: ['student', 'lessons', 'my-lesson', 'detail-raw', id, myAcademy()],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/student/lesson-registration/${id}`)
        })(id)),
    })
}


export const useApiSearchTeacherLessons = (args = {}) => {
    return useQuery({
        queryKey: ['teacher', 'lessons', 'list', args, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            const searchParams = objectToQueryString(config);
            return generalRequest.get(`/teacher/lessons?` + searchParams, config)
        })(args)),
    })
}


export const useApiGetTimeSummaryDetail = (args = {}) => {
    return useQuery({
        queryKey: ['teacher', 'time', 'summary', args, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/teacher/times/summary`, {params: config})
        })(args)),
    })
}

export const useApiReadTeacherLessonDetail = (id) => {
    return useQuery({
        queryKey: ['teacher', 'lessons', 'lesson', 'detail', id, myAcademy()],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/teacher/lessons/${id}`)
        })(id)),
    })
}
